<template>
  <div class="page news-detail">
    <div class="page-body">
      <div class="panel">
        <div class="panel-body">
          <div class="html-view">
            <div class="head">
              <div class="title">{{ infoData.title }}</div>
              <div class="sec_list">
                <div class="item">
                  <span>作者/摄影：</span>
                  <span>{{ infoData.writer }}</span>
                </div>
                <div class="item">
                  <span>浏览量：</span>
                  <span>{{ infoData.view_count }}</span>
                </div>
              </div>
              <el-button class="btnCollect" type="primary" plain :loading="isCollectLoad" @click="handleCollect()">
                <span>{{ formCollect ? '取消采集' : '采集到云库' }}</span>
                <img src="@/assets/home/gather.png" alt style="height: 14px; vertical-align: middle" />
              </el-button>
            </div>
            <img class="carouse-img" :src="currData" :style="{ height: carouselHeight }" />
            <template v-if="dataList.length">
              <base-swiper class="swiper" ref="swiper" :num="imgNum" :height="swiperHeight" :gap="30"
                style="margin-top: 20px;">
                <base-swiper-item v-for="(item, index) of dataList" :key="index" :gap="30">
                  <div class="swiper-box">
                    <img class="swiper-img" :class="{ active: index === currIndex }" :src="item.url" alt="item.title"
                      :style="{ height: swiperImgHeight }" @click="clickSwiper(item, index)" />
                  </div>
                </base-swiper-item>
              </base-swiper>
            </template>
          </div>
          <!-- <div class="sequence-page">
            <el-button type="text">上一篇</el-button>
            <el-button type="text">下一篇</el-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getActivePictureList, getActivePictureInfo } from "@/api/activity"
import { setCollect } from "@/api/common"
import BaseSwiper from "./swiper/base-swiper"
import BaseSwiperItem from "./swiper/base-swiper-item"
// import dayjs from "dayjs"
export default {
  name: "PictureDetail",
  components: {
    "base-swiper": BaseSwiper,
    "base-swiper-item": BaseSwiperItem,
  },
  data() {
    return {
      queryData: {},
      id: "",
      infoData: {},
      queryParams: {
        keyword: "",
        per_page: 16,
        page: 1,
      },
      dataList: [], // 存放swiper列表的数据
      currData: "", // 当前图片
      currIndex: 0, // 当前指针
      defaultImg: require("@/assets/default/image02.jpg"),
      imgNum: 3, // 多图轮播单次显示图片
      autoTimer: null, // 自动轮播定时器
      autoPlay: true, // 是否自动播放
      isRun: false,
      formCollect: false,
      isCollectLoad: false,
    }
  },
  filters: {
    // dataformat: function (value) {
    //   if (!value) return ""
    //   return dayjs.unix(value).format("YYYY-MM-DD")
    // },
  },
  computed: {
    swiperHeight() {
      if (window.innerWidth <= 640) return 200
      if (window.innerWidth <= 1200) return 260
      return 330
    },
    swiperImgHeight() {
      if (window.innerWidth <= 640) return '170px'
      if (window.innerWidth <= 1200) return '230px'
      return '300px'
    },
    carouselHeight() {
      if (window.innerWidth <= 640) return '300px'
      if (window.innerWidth <= 1200) return '600px'
      return '1000px'
    }
  },
  watch: {
    currIndex: {
      handler(newVal, oldVal) {
        if (newVal >= 0 && this.dataList.length) {
          this.currData = this.dataList[newVal].url;
        }
        if (this.dataList.length > this.imgNum && this.$refs['swiper']) {
          this.$nextTick(() => {
            this.$refs['swiper'].scrollToIndex(newVal)
          })
        }
      },
    }
  },
  created() {
    this.queryData = this.$route.query || {}
    this.id = this.queryData?.id ?? ""
    let c_page = this.queryData?.cPage ?? 0
    this.queryParams.page = Number(c_page)
    this.getInfo()
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    // 获取详情信息
    getInfo() {
      getActivePictureInfo({ id: this.id }).then((res) => {
        if (res.code === 0 && res.data) {
          this.infoData = res.data
          this.dataList = res.data.article_gallery;
          if (this.dataList && this.dataList.length) {
            this.currIndex = 0;
            this.currData = this.dataList[0].url;
          } else {
            this.currData = res.data.cover;
            this.currIndex = -1;
          }
          this.formCollect = res.data.is_collect_activity ? true : false
          this.$nextTick(() => {
            this.startAutoPlay()
          })
        }
      }).catch(() => { })
    },
    // getList () {
    //   getActivePictureList(this.queryParams).then((res) => {
    //     if (res.code === 0 && res.data) {
    //       console.log(res.data);
    //       this.dataList = res.data?.data ?? []
    //       let inx = this.queryData?.index ?? 0
    //       this.currIndex = Number(inx)
    //     }
    //   }).catch(() => { })
    // },
    // 当图片加载失败时，将图片地址设置为默认图片
    handleError(e) {
      e.target.src = this.defaultImg
    },
    clickSwiper(val, i) {
      this.stopAutoPlay()
      this.currIndex = i;
      this.startAutoPlay()
    },
    startAutoPlay() {
      if (!this.dataList.length || this.dataList.length <= 1) return
      this.stopAutoPlay()
      this.autoTimer = setInterval(() => {
        if (this.currIndex >= this.dataList.length - 1) {
          this.currIndex = 0
        } else {
          this.currIndex++
        }
      }, 3000)
    },
    stopAutoPlay() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer)
        this.autoTimer = null
      }
    },
    // 采集到云库
    handleCollect() {
      this.isCollectLoad = true
      let params = {
        id: this.id,
        type: 2
      }
      setCollect(params).then((res) => {
        this.isCollectLoad = false
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: this.formCollect ? '取消采集成功!' : '采集成功!'
          })
          this.getInfo()
        }
      }).catch(() => { })
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  background-color: #fff;

  .page-body {
    position: relative;

    .panel {
      padding: 10px;
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 20px;

      .panel-head {
        padding: 10px;
      }

      .panel-title {
        color: #000;
        font-size: 24px;
        font-weight: bold;
        line-height: 40px;
      }

      .panel-body {
        padding: 10px;
      }
    }

    .html-view {
      color: #333;
      font-size: 14px;
      font-weight: 400;
      line-height: 30px;
      overflow: hidden;
      /* 溢出隐藏 */
      position: relative;

      /* 子绝父相，这里是为了给伪元素设置定位*/
      .head {
        text-align: center;
        margin-bottom: 30px;
        position: relative;

        .btnCollect {
          position: absolute;
          right: 0px;
          top: 0px;
        }
      }

      .title {
        color: #000;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      .sec_list {
        color: #999;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;

        .item {
          display: inline-block;
          margin: 0 10px;
        }
      }

      .carouse-img {
        width: 100%;
        height: 1000px;
        background-size: contain;
      }

      .swiper-box {
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        .swiper-img {
          width: 100%;
          object-fit: cover;
          border-radius: 5px;
          overflow: hidden;
        }

        .swiper-img.active {
          border: 3px solid #005cbb;
          box-shadow: 0px 0px 12px 0px rgba(0, 92, 187, 0.5);
          transform: scale(1.05);
          transition: all 0.3s ease;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    .page-body {
      padding: 10px;

      .panel {
        .panel-title {
          font-size: 18px;
          line-height: 1.4;
        }
      }

      .html-view {
        .head {
          margin-bottom: 15px;

          .title {
            font-size: 18px;
          }

          .sec_list {
            .item {
              margin: 0 5px;
            }
          }
        }

        .carouse-img {
          height: 300px;
        }

        .swiper-box {
          .swiper-img {
            height: 250px;
          }
        }

        ::v-deep .swiper {
          .switch-btn {
            width: 30px;
            margin: 0;

            .icon {
              font-size: 18px;
            }
          }

          .base-swiper-item {
            padding: 8px 0;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    .page-body {
      .html-view {
        .carouse-img {
          height: 600px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}
</style>